import { Col, Row, Space } from "components/primitives";
import { ChangeEvent, useEffect, useState } from "react";
import styled from "styled-components";

const MoneySetting = (props: any) => {
  const { info, data, setData }: any = props;

  const [number, setNumber] = useState<number | string>(0);
  const [range, setRange] = useState<any>({ lowerRange: 0, higherRange: 0 });

  useEffect(() => {
    setNumber(props.data.target);
  }, []);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setNumber(value || "");

    setData({ ...data, target: value });
  };

  const onChange = (key: string, value: string) => {
    setData({ ...data, [key]: value });
  };

  const onChangeRange = (key: string, value: string | number) => {
    setRange({ ...range, [key]: value });
  };

  const setRandomRange = () => {
    const maxRange = Math.max(range.lowerRange || 0, range.higherRange || 0);
    const minRange = Math.min(range.lowerRange || 0, range.higherRange || 0);

    const rawValue = Math.random() * (maxRange - minRange) + minRange;
    const roundedValue = Math.round(rawValue * 2) / 2;
    const formattedRangeValue = roundedValue.toFixed(2);

    setData({ ...data, range: formattedRangeValue });
  };

  return (
    <OuterContainer noMargin>
      <p className="label">{info.limit.label}</p>
      <Input type="number" value={number} onChange={handleChange} />
      <Space gap={16} />
      {data.theme === "exchange" && (
        <>
          <p className="label">{info.limit.range}</p>
          <Row gap={2}>
            <Input
              halfWidth
              type="number"
              value={range.lowerRange}
              onChange={(e) => {
                if (e.target.value === "") {
                  onChangeRange("lowerRange", "");
                  return;
                }
                onChangeRange("lowerRange", +e.target.value);
              }}
            />
            <Input
              halfWidth
              type="number"
              value={range.higherRange}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "") {
                  onChangeRange("higherRange", "");
                  return;
                }
                onChangeRange("higherRange", +value);
              }}
            />
          </Row>
          <Space gap={8} />
          <OptionButton onClick={setRandomRange} center>
            Generate
          </OptionButton>
        </>
      )}

      <Space gap={16} />
      <p className="label">{info.limit.theme_label}</p>
      <Row gap={8}>
        <OptionButton
          selected={data.theme === "money_lab"}
          onClick={() => onChange("theme", "money_lab")}
        >
          Counting Money
        </OptionButton>
        <OptionButton
          selected={data.theme === "exchange"}
          onClick={() => {
            onChange("theme", "exchange");
          }}
        >
          Price and Change
        </OptionButton>
      </Row>
    </OuterContainer>
  );
};

export default MoneySetting;

const OuterContainer = styled(Col)<{ noMargin: boolean }>`
  margin-bottom: ${(props) => (props.noMargin ? "0px" : "35px")};

  .label {
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 12pt;
  }
`;

const Input = styled.input<{ halfWidth?: boolean }>`
  padding: 0.4rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: ${(props) => (props.halfWidth ? "50%" : "100%")};

  &[type="number"] {
    -moz-appearance: textfield;
    -webkit-appearance: none;
    appearance: none;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  &:focus {
    outline: none;
    border-color: #007bff;
  }
`;

const OptionButton = styled.button<{ selected?: boolean; center?: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.center ? "center" : "flex-start")};
  gap: 8px;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border: 2px solid ${(props) => (props.selected ? "#007BFF" : "#ccc")};
  background-color: ${(props) => (props.selected ? "#e7f1ff" : "#f0f0f0")};
  color: ${(props) => (props.selected ? "#007BFF" : "#333")};
  border-radius: 5px;

  &:hover {
    border-color: #007bff;
    background-color: #e7f1ff;
  }
`;
